var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightGray18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9C12 9.09566 11.9841 9.18535 11.9523 9.26906C11.9205 9.35276 11.8664 9.43049 11.7901 9.50224L8.27863 12.8027C8.13868 12.9342 7.96056 13 7.74427 13C7.52799 13 7.34987 12.9342 7.20992 12.8027C7.06997 12.6712 7 12.5037 7 12.3004C7 12.0972 7.06997 11.9297 7.20992 11.7982L10.187 9L7.20992 6.20179C7.06997 6.07025 7 5.90284 7 5.69955C7 5.49626 7.06997 5.32885 7.20992 5.19731C7.34987 5.06577 7.52799 5 7.74427 5C7.96056 5 8.13868 5.06577 8.27863 5.19731L11.7901 8.49776C11.8664 8.56951 11.9205 8.64723 11.9523 8.73094C11.9841 8.81465 12 8.90433 12 9Z",
    fill: "#627487"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightGray18);
export default __webpack_public_path__ + "static/media/arrow_right_gray_18.5e51d92997612d0c245d9811e96544d1.svg";
export { ForwardRef as ReactComponent };